// src/NotifyButton.tsx
export function NotifyButton() {
  const notify = () => {
    navigator.serviceWorker.ready.then((registration) => {
      registration.active?.postMessage({
        type: 'show-notification',
        payload: {
          title: 'Hello!',
          body: 'Click me to open a URL.',
          url: 'https://example.com',
        },
      });
    });
  };

  return <button onClick={notify}>Notify via Service Worker</button>;
}